module.exports = {
      id: "trending-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#trending",
      toString: function () {
        return this.url;
      }
    }